// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chats .box {
  position: relative;
}
.chats .box .chat-msg-image .image-hover {
  display: none;
}

.chats .box:hover .chat-msg-image .image-hover {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/secure-image/secure-image.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,aAAA;AACR;;AAGA;EACI,cAAA;AAAJ","sourcesContent":[".chats .box {\n    position: relative;\n    .chat-msg-image{\n    .image-hover {\n        display: none;\n    }\n}\n}\n.chats .box:hover .chat-msg-image .image-hover {\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
